import { useTranslation } from 'react-i18next';
import { ReactComponent as ActorIcon } from './assets/actors.svg';
import { ReactComponent as PublicationIcon } from './assets/publications.svg';
import { ReactComponent as ViewsIcon } from './assets/views.svg';
import { ReactComponent as EngagementIcon } from '../../assets/engagement.svg';
import { SummaryIcon } from './SummaryIcon';
import { formatWithCustomGigaBillion } from '../../utils/fomatNumbers';
import styles from './SummaryPanel.module.scss';


const mapTitle = {
  allActors: { title: 'All actors', icon: <ActorIcon /> },
  inauthenticActors: { title: 'Inauthentic accounts', icon: <ActorIcon /> },
  actors: { title: 'Actors', icon: <ActorIcon /> },
  publications: { title: 'Publications', icon: <PublicationIcon /> },
  views: { title: 'Views', icon: <ViewsIcon /> },
  reactions: { title: 'Engagement', icon: <EngagementIcon /> },
};

export const SummaryMainCard = ({ title, data, isActive, onClick }) => {
  const { t } = useTranslation();

  return (
    <div
      className={
        isActive
          ? `${styles.summaryMainCard} ${styles.active}`
          : styles.summaryMainCard
      }
      onClick={() => onClick()}
    >
      <div className={styles.summaryCardContainer}>
        <div className={styles.summaryMainCardHeader}>
          <div className={styles.summaryMainCardIcon}>
            {<SummaryIcon icon={mapTitle[title].icon} isActive={isActive} />}
          </div>
        </div>

        <div className={styles.summaryMainCardBody}>
          <div className={styles.summaryMainCardTitle}>
            {t(mapTitle[title].title)}
          </div>
          <div className={styles.summaryMainCardData}>
            {formatWithCustomGigaBillion(data)}
          </div>
        </div>
      </div>
    </div>
  );
};
